export enum AppointmentsRequestCancelDataTestId {
  APPOINTMENT_REQUEST_CANCEL_TITLE = 'appointments--request-cancel-title',
  APPOINTMENT_REQUEST_CANCEL_FIELD_EMAIL = 'appointments--request-cancel-field-email',
  APPOINTMENT_REQUEST_CANCEL_FIELD_PHONE = 'appointments--request-cancel-field-phone',
  APPOINTMENT_REQUEST_CANCEL_FIELD_REASON = 'appointments--request-cancel-field-reason',
  APPOINTMENT_REQUEST_CANCEL_FIELD_CUSTOM_REASON = 'appointments--request-cancel-field-custom-reason',
  APPOINTMENT_REQUEST_CANCEL_SUBMIT_BUTTON = 'appointments--request-cancel-submit-button',
  APPOINTMENT_REQUEST_CANCEL_SUCCESS_MODAL = 'appointments--request-cancel-success-modal',
  APPOINTMENT_REQUEST_CANCEL_ERROR_MODAL = 'appointments--request-cancel-error-modal',
  APPOINTMENT_REQUEST_CANCEL_UNAVAILABLE_MODAL = 'appointments--request-cancel-unavailable-modal',
}
